class PriceBreakdownButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', function () {
      const bodyRect = document.body.getBoundingClientRect();
      const elemRect = document.querySelector('.CartTotals__summary-wrapper').getBoundingClientRect();
      const offset = elemRect.top - bodyRect.top - 76;

      window.scrollTo({
        left: 0,
        top: offset,
        behavior: 'smooth',
      });
    });
  }
}

export default PriceBreakdownButton;
